import React, { useEffect, useRef, useState } from "react";
import { SvgIcon } from "../../common/SvgIcon";
import { FloatingLogoWrap } from "./styles";
import { FloatingLogoProps } from "./types";

const clamp = (value: number, min: number, max: number) =>
	Math.min(max, Math.max(min, value));

const FloatingLogo: React.FC<FloatingLogoProps> = () => {
	const [offsetY, setOffsetY] = useState(0);
	const rafId = useRef<number | null>(null);

	useEffect(() => {
		const onScroll = () => {
			if (rafId.current !== null) return;
			rafId.current = window.requestAnimationFrame(() => {
				rafId.current = null;
				const next = clamp(window.scrollY * 0.15, 0, 260);
				setOffsetY(next);
			});
		};

		onScroll();
		window.addEventListener("scroll", onScroll, { passive: true });
		return () => {
			window.removeEventListener("scroll", onScroll);
			if (rafId.current !== null) {
				window.cancelAnimationFrame(rafId.current);
			}
		};
	}, []);

	return (
		<FloatingLogoWrap
			aria-hidden="true"
			style={{ transform: `translateY(${offsetY}px)` }}
		>
			<SvgIcon
				src="logos/logo-transparent.svg"
				width="433px"
				height="577px"
			/>
		</FloatingLogoWrap>
	);
};

export default FloatingLogo;
